import type { RelayGraphQLError } from '@confluence/relay-errors/entry-points/RelayError.ts';
import type { ReactNode } from 'react';
import React from 'react';

import { isStatusCodeError } from '@confluence/error-types/entry-points/isStatusCodeError.ts';
import { KnownErrorBoundary } from '@confluence/known-error-boundary/entry-points/KnownErrorBoundary.ts';

type UnauthorizedErrorBoundaryProps = {
	children: ReactNode;
	onError?: (error: any) => void;
	renderOnError: (error: any) => ReactNode | null;
};

export const UnauthorizedErrorBoundary = (
	props: UnauthorizedErrorBoundaryProps,
): React.JSX.Element => <KnownErrorBoundary isKnownError={isUnauthorizedError} {...props} />;

/**
 * https://pug.jira-dev.com/wiki/spaces/CCB/pages/4709260932/GraphQL+Errors+Contract+for+Status+Code+401+and+403
 */

const isLegacyUnauthorizedGraphQLError = (error: Error | RelayGraphQLError) =>
	(error as RelayGraphQLError)?.extensions?.data?.authorized === false;

export const isUnauthorizedError = (error: Parameters<typeof isStatusCodeError>[0]): boolean =>
	isStatusCodeError(error, '403', isLegacyUnauthorizedGraphQLError);
